<template>
    <div class="holder">
        <el-input v-if="readonly" v-model="selected.name" type="info" disabled>
            <template slot="prepend"
                >Supplier</template
            >
        </el-input>
        <el-input v-else-if="selected" v-model="selected.name" disabled>
            <template slot="prepend"
                >Supplier</template
            >
            <template slot="append">
                <el-button
                    circle
                    type="info"
                    icon="el-icon-edit"
                    @click="clearSupplier"
                />
            </template>
        </el-input>
        <el-autocomplete
            v-else
            v-model="search"
            :fetch-suggestions="supplierSearch"
            placeholder="Select a supplier"
            @select="handleSelect"
        >
            <template slot-scope="{ item }">
                {{ item.name }}
            </template>
            <template slot="prepend"
                >Supplier</template
            >
        </el-autocomplete>
    </div>
</template>
<script>
import { SupplierService } from "Services/SupplierService";

export default {
    props: {
        selectedSupplier: {
            type: Object,
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            search: "",
            selected: null,
        };
    },
    watch: {
        selectedSupplier() {
            this.selected = this.selectedSupplier;
        },
    },
    created() {
        this.selected = this.selectedSupplier;
    },
    methods: {
        async supplierSearch(queryString, cb) {
            const supplierResponse = await SupplierService.searchAll(
                queryString
            );
            cb(supplierResponse.data);
        },
        handleSelect(item) {
            this.selected = item;
            this.$emit("selected:supplier", item);
        },
        clearSupplier() {
            this.selected = null;
        },
    },
};
</script>
<style lang="scss" scoped>
/deep/ .el-autocomplete {
    display: block;
}
</style>
